import api from './api';

const prefix = 'sync-status';

export default {
  get() {
    return api.get(`${prefix}`);
  },
};
